import { checkoutPopupButtonClicked, checkoutPopupViewed } from "@/lib/mixpanels/mixpanel";
import { PASSES_LANDING } from "@/settings/constant";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDialogStore } from "src/store/useDialogStore";
const UPGRADE_GUARD_CASES = {
    // 패키지 또는 플랜 아이템이 유효하지 않은 주문
    invalidOrder: {
        dialogId: "upgrade-invalid-order",
        type: "유효하지 않은 주문",
        title: "더 이상 유효하지 않은 주문 건이에요.",
        confirmText: "이용권 보러가기",
        blockDismiss: true
    },
    // 주문 생성일과 현재 날짜가 다른 경우 (제안 금액이 만료됨)
    priceMismatch: {
        dialogId: "upgrade-price-mismatch",
        type: "업셀링 가격 제안일 초과",
        title: "주문을 다시 시도해주세요.",
        description: "이용권 업그레이드는 기간에 따라 제안 금액이 달라져요.\n지금 시점을 기준으로 다시 금액을 제안드릴게요.",
        confirmText: "이용권 보러가기"
    }
};
/**
 * upgrade 주문 엣지케이스 검증
 *
 * 주문이 더 이상 유효하지 않거나 제안 금액이 만료된 경우
 * 안내 다이얼로그를 띄우고 이용권 페이지로 유도한다.
 */ export const useUpgradeOrderGuard = (param)=>{
    let { orderType , paymentData , paymentLoading  } = param;
    const router = useRouter();
    const { open  } = useDialogStore();
    useEffect(()=>{
        if (orderType !== "upgrade" || !paymentData || paymentLoading) return;
        const order = paymentData;
        const isInvalidOrder = order.canPurchase === false || order.packageAvailable === false || order.planItemActive === false;
        const isExpiredOffer = new Date(order.createdAt).toDateString() !== new Date().toDateString();
        const guardCase = isInvalidOrder ? UPGRADE_GUARD_CASES.invalidOrder : isExpiredOffer ? UPGRADE_GUARD_CASES.priceMismatch : null;
        if (!guardCase) return;
        const { dialogId , type , title , description , confirmText , blockDismiss  } = guardCase;
        // Mixpanel Body는 설명이 있으면 설명을, 없으면 제목을 그대로 보낸다
        const eventBase = {
            Position: "주문 결제 페이지",
            Type: type,
            Title: title,
            Body: description !== null && description !== void 0 ? description : title
        };
        // mx-396 / Popup Viewed
        checkoutPopupViewed({
            ...eventBase,
            "CTA Button Name": confirmText,
            "CTA Button Url": PASSES_LANDING
        });
        open({
            id: dialogId,
            type: "confirm",
            props: {
                title,
                ...description && {
                    description
                },
                confirmText,
                onConfirm: ()=>{
                    // mx-397 / Popup Button Clicked
                    checkoutPopupButtonClicked({
                        ...eventBase,
                        "Button Name": confirmText,
                        "Button Url": PASSES_LANDING
                    });
                    router.push(PASSES_LANDING);
                },
                ...blockDismiss && {
                    onOpenChange: ()=>{}
                }
            }
        });
    // NOTE: 의존성은 추출 전 동작을 그대로 유지한다. (open/router 누락은 별도 커밋에서 정리)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderType,
        paymentData,
        paymentLoading
    ]);
};
